import theme from 'stories/utils/theme'
import styled from 'styled-components'

interface Props {
    makeTextBolder?: boolean
    isDarkTheme?: boolean
}

export const RevampArticleStyles = styled.article<Props>`
    min-height: 100%;
    width: 100%;
    display: grid;
    gap: 15px;

    section {
        all: unset;
    }
    div {
        padding: 7.5px 0;
    }
    div {
        text-align: justify;
        font-family: var(--font-inter);
        font-weight: 400;
    }
    h1 {
        font-family: var(--font-inter);
        font-size: 30px;
        font-weight: 650;
        line-height: 36px;
        color: ${theme.colors.white};
        margin: 0;
        text-align: left !important;
    }
    h2 {
        font-family: var(--font-inter);
        font-size: 23px;
        font-weight: 650;
        line-height: 28px;
        letter-spacing: -0.2px;
        color: ${theme.colors.lightGrayBackground};
        margin: 0;
        padding-bottom: 10px;
        text-align: left !important;
    }
    h3 {
        text-transform: none;
        font-family: var(--font-inter);
        font-size: 20px;
        font-weight: 600;
        line-height: 30px;
        color: ${theme.colors.white};
        margin-bottom: 0px;
    }
    h4 {
        text-transform: none;
        font-family: var(--font-inter);
        font-size: 18px;
        font-weight: 600;
        line-height: 26px;
        color: ${theme.colors.white};
        margin-bottom: 0px;
    }
    ol,
    ul,
    div {
        margin: 0;
        display: grid;
        gap: 0px;
        li {
            margin: 0;
        }
    }

    pre {
        margin: 0;
    }
    && code,
    p,
    a,
    span,
    li {
        font-family: var(--font-inter) !important;
        font-size: 17px !important;
        font-weight: 400;
        line-height: 27px;
        letter-spacing: 0.3px;
        color: ${theme.colors.lightGrayBackground};
        margin: 0;
    }
    a {
        color: ${theme.colors.deepSeaBlue};
    }
    b,
    strong {
        font-family: var(--font-inter) !important;
        font-weight: 550;
        color: inherit;
        font-size: inherit;
        line-height: inherit;
    }

    blockquote {
        padding: 16px;
        margin: 0;
        position: relative;
        border-radius: ${theme.borderRadius.normal};
        background: linear-gradient(90deg, #14183a 0%, #030e1a 100%);

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: ${theme.borderRadius.normal};
            padding: 1px;
            background: linear-gradient(90deg, #5767d6 0%, #0075c2 100%);
            mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            mask-composite: xor;
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            pointer-events: none;
        }
    }
    * {
        word-break: break-word;
    }
    code {
        white-space: normal;
    }
`
